import { Suspense }  from "react";
import { BrowserRouter  } from "react-router-dom";
import { Navigate }      from "react-router-dom";
import { Route }         from "react-router-dom";
import { Routes }        from "react-router-dom";
import { routes } from "./routes";
import { MoonLoader } from "react-spinners";


const Navigation = () => {

  return (
      <Suspense
        fallback={
          <div className="spinner" >
            <MoonLoader size={50} color={"#0D3B70"} />
          </div>
        }
      >
        <BrowserRouter basename="/">
          <Routes>
            <Route path={"/"} element={<Navigate to={`/agenda`} />} />
            <Route exact path={"/*"} Component={routes[0].Component} />

            {routes.map(({ path, Component, name }) => (
              <Route exact path={path} Component={Component} key={name} />
            ))}
          </Routes>
        </BrowserRouter>
      </Suspense>
  );
}; 

export default Navigation;